<template>
<div class="perusahaan">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>

          <v-btn v-if="role==='gov.agroforestcape@gmail.com'" color="primary" @click="tambahkanPemerintah"><v-icon>add</v-icon><h5>Tambahkan Pemerintah</h5></v-btn>
     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers2"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          v-if="role==='gov.agroforestcape@gmail.com'"
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.namaInstansi }}</td>
            <td class="data-fonts">{{ props.item.kontakInstansi }}</td>
            <td class="data-fonts" v-if="props.item.website">{{ props.item.website }}</td>
            <td class="data-fonts" v-else>-</td>
            <td class="data-fonts">Rp. {{ formatPrice(props.item.nilaiBantuan) }}.00</td>
            <td class="data-fonts">{{ props.item.tujuanBantuan }}</td>
            <td class="data-fonts">{{ props.item.alokasiPenggunaanDana }}</td>
            <td class="data-fonts">{{ props.item.jangkaWaktu }}</td>
            <!-- <td class="data-fonts">{{ props.item.indikatorKeberhasilan }}</td>
            <td class="data-fonts">{{ props.item.alamatDesa }}</td>
            <td class="data-fonts">{{ props.item.alamatKecamatan }}</td>
            <td class="data-fonts">{{ props.item.alamatKabupaten }}</td>
            <td class="data-fonts">{{ props.item.alamatProvinsi }}</td> -->
            <td class="data-fonts">
              <v-btn depressed outline icon fab dark color="primary" small :to="editPemerintah(props.item.pemerintahID)">
                <v-icon>fas fa-file-alt</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>

        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          v-else
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.namaInstansi }}</td>
            <td class="data-fonts">{{ props.item.kontakInstansi }}</td>
            <td class="data-fonts" v-if="props.item.website">{{ props.item.website }}</td>
            <td class="data-fonts" v-else>-</td>
            <td class="data-fonts">Rp. {{ formatPrice(props.item.nilaiBantuan) }}.00</td>
            <td class="data-fonts">{{ props.item.tujuanBantuan }}</td>
            <td class="data-fonts">{{ props.item.alokasiPenggunaanDana }}</td>
            <td class="data-fonts">{{ props.item.jangkaWaktu }}</td>
            <!-- <td class="data-fonts">{{ props.item.indikatorKeberhasilan }}</td>
            <td class="data-fonts">{{ props.item.alamatDesa }}</td>
            <td class="data-fonts">{{ props.item.alamatKecamatan }}</td>
            <td class="data-fonts">{{ props.item.alamatKabupaten }}</td>
            <td class="data-fonts">{{ props.item.alamatProvinsi }}</td> -->
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getPemerintah } from '@/api/pemerintah';
import { Items as Users } from '@/api/pemerintah';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Nama Instansi',
            value: 'namaInstansi',
          },
          {
            text: 'Kontak Instansi',
            value: 'kontakInstansi'
          },
          {
            text: 'Website',
            value: 'website'
          },
          {
            text: 'Nilai Bantuan',
            value: 'nilaiBantuan'
          },
          {
            text: 'Tujuan Bantuan',
            value: 'tujuanBantuan'
          },
          {
            text: 'Alokasi Penggunaan Dana',
            value: 'alokasiPenggunaanDana'
          },
          {
            text: 'Jangka Waktu (Bulan)',
            value: 'jangkaWaktu'
          },


          // {
          //   text: 'Indikator Keberhasilan (Bulan)',
          //   value: 'indikatorKeberhasilan'
          // },
          // {
          //   text: 'Alamat Desa',
          //   value: 'alamatDesa'
          // },
          // {
          //   text: 'Alamat Kecamatan',
          //   value: 'alamatKecamatan'
          // },
          // {
          //   text: 'Alamat Kabupaten',
          //   value: 'alamatKabupaten'
          // },
          // {
          //   text: 'Alamat Provinsi',
          //   value: 'alamatProvinsi'
          // },
        ],
        headers2: [
          {
            text: 'Nama Instansi',
            value: 'namaInstansi',
          },
          {
            text: 'Kontak Instansi',
            value: 'kontakInstansi'
          },
          {
            text: 'Website',
            value: 'website'
          },
          {
            text: 'Nilai Bantuan',
            value: 'nilaiBantuan'
          },
          {
            text: 'Tujuan Bantuan',
            value: 'tujuanBantuan'
          },
          {
            text: 'Alokasi Penggunaan Dana',
            value: 'alokasiPenggunaanDana'
          },
          {
            text: 'Jangka Waktu (Bulan)',
            value: 'jangkaWaktu'
          },


          // {
          //   text: 'Indikator Keberhasilan (Bulan)',
          //   value: 'indikatorKeberhasilan'
          // },
          // {
          //   text: 'Alamat Desa',
          //   value: 'alamatDesa'
          // },
          // {
          //   text: 'Alamat Kecamatan',
          //   value: 'alamatKecamatan'
          // },
          // {
          //   text: 'Alamat Kabupaten',
          //   value: 'alamatKabupaten'
          // },
          // {
          //   text: 'Alamat Provinsi',
          //   value: 'alamatProvinsi'
          // },
          {
            text: 'Tindakan',
            value: '',
          },
        ],
        items: Users,
      },
      role: localStorage.userEmail,
    };
  },

  computed: {
    users () {
      return getPemerintah();
    },
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    tambahkanPemerintah(){
      window.getApp.$emit('APP_TAMBAHKAN_PEMERINTAH');
    },

    editPemerintah (id) {
      return '/edit-perusahaan/' + id;
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    },

    formatPrice(value) {
      let val = (value/1)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }
</style>
